import { render, staticRenderFns } from "./AddLoss.vue?vue&type=template&id=ea9b2a64&scoped=true&"
import script from "./AddLoss.vue?vue&type=script&lang=js&"
export * from "./AddLoss.vue?vue&type=script&lang=js&"
import style0 from "./AddLoss.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddLoss.vue?vue&type=style&index=1&id=ea9b2a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9b2a64",
  null
  
)

export default component.exports